import axios from "axios";
import Config from "src/config";

const BASE = Config.dev ? Config.url_dev : Config.urlBackend;

export const listMktPosts = (clienteId, querys) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/${clienteId}/mkt/posts${querys || ''}`
    });
};

export const getMktPost = (id) => {
    return axios({
        method: "get",
        url: `${BASE}/api/v2/mkt/posts/${id}`
    });
};

export const createMktPost = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${BASE}/api/v2/${clienteId}/mkt/posts`,
        data
    });
};

export const updateMktPost = (clienteId, id, data) => {
    return axios({
        method: "put",
        url: `${BASE}/api/v2/${clienteId}/mkt/posts/${id}`,
        data
    });
};

export const deleteMktPost = (clienteId, id) => {
    return axios({
        method: "delete",
        url: `${BASE}/api/v2/${clienteId}/mkt/posts/${id}`
    });
};

export const publishMktPost = (id) => {
    return axios({
        method: "post",
        url: `${BASE}/api/v2/mkt/posts/${id}/publish`
    });
};
